module.exports = __webpack_public_path__ + "img/defaultIcon.69154871.jpg";